import * as React from 'react';
import { cn } from '@/lib/cn';
import { ArticleDto } from '@/features/programs/model/types';
import { R } from '@/features/programs/resources/ProgramsResources.resx';
import { HorizontalContainer, VerticalContainer } from '@/components';

interface ArticleProps {
    article: ArticleDto;
    isCoveredByOverlay?: boolean;
}

export const Article: React.FC<ArticleProps> = ({
    article,
    isCoveredByOverlay = false,
}) => {
    const [seenArticles, setSeenArticles] = React.useState<string[]>(() => {
        if (typeof window === 'undefined') return [];
        return JSON.parse(localStorage.getItem('seenArticles') || '[]');
    });
    const isNew = Boolean(article.isNew && !seenArticles.includes(article.url));

    return (
        <a
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
                'article-card block w-full overflow-hidden rounded-2xl border bg-(--color-bg-surface) transition-shadow duration-200 hover:bg-(--color-bg-surface-hover) focus:ring-(--color-border-focus-primary) focus:ring-offset-2 active:ring-2 active:ring-offset-white active:outline-none',
                isNew
                    ? 'border-(--color-border-attention)'
                    : 'border-(--color-border-default)',
                isCoveredByOverlay && 'border-transparent',
            )}
            onClick={(event) => {
                const seen = JSON.parse(
                    localStorage.getItem('seenArticles') || '[]',
                );
                if (!seen.includes(article.url)) {
                    const updated = [...seen, article.url];
                    localStorage.setItem(
                        'seenArticles',
                        JSON.stringify(updated),
                    );
                    setSeenArticles(updated);
                }
                event.currentTarget.blur();
            }}
        >
            <div className="h-[150px] w-full overflow-hidden">
                <img
                    src={article.image}
                    alt={article.title}
                    className="h-full w-full object-cover"
                />
            </div>
            <VerticalContainer spacing="sm" className="h-[150px] p-3">
                <HorizontalContainer className="items-center justify-between pt-1">
                    {article.category && (
                        <div className="text-sm font-bold text-(--color-text-category)">
                            {article.category}
                        </div>
                    )}
                    {isNew && (
                        <span className="rounded-lg bg-(--color-bg-attention) px-2 text-sm font-semibold text-(--color-text-attention)">
                            {R.ArticleNewLabel}
                        </span>
                    )}
                </HorizontalContainer>
                <h5 className="mb-2 line-clamp-3 overflow-hidden text-ellipsis text-(--color-text-heading)">
                    {article.title}
                </h5>
            </VerticalContainer>
        </a>
    );
};
